import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* updateAssignment({ payload: { id, values, onSuccess, onError, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.modifiers.assignments.update, id, data: values });

    onSuccess && onSuccess();
    yield put(actions.updateAssignmentDone(data.result));
  } catch (error) {
    onError && onError();
    yield handleErrors({
      error,
      putErrorData: actions.updateAssignmentFailed,
      handledErrors,
      endpoint: api.modifiers.assignments.update.url
    });
  }
}

export const updateAssignmentSaga = takeEvery(types.UPDATE_ASSIGNMENT_REQUEST, updateAssignment);